// page/router.js
// page下管理的路由文件
export default [
	{
		path: '/dashboard',
		component: () => import('./Dashboard.vue'),
		meta: {
			// title: '系统首页'
			title:'Sidebar.fatherTitle'
		}
	}
];



// WEBPACK FOOTER //
// ./src/components/page/router.js